<template>
  <v-container
    fluid
    class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background-color: #f6f4f1;"
  >
    <v-card
      elevation="18"
      width="450"
      class="pa-8 rounded-2xl"
      style="background-color: #ffffff; border: 1px solid #e0dcd6;"
    >
      <!-- TÍTULO -->
      <div class="text-center mb-8">
        <h2 class="text-h5 font-weight-bold mb-1" style="color: #152a34;">
          Recuperar Senha
        </h2>
        <p class="text-body-2" style="color: #6b7280;">
          Informe seu e-mail para enviarmos um código de verificação.
        </p>
      </div>

      <v-form @submit.prevent="handleForgotPassword" ref="formRef">
        <v-text-field
          v-model="email"
          label="E-mail"
          type="email"
          prepend-inner-icon="mdi-email-outline"
          variant="outlined"
          required
          class="mb-6"
          color="#b99a52"
          :error-messages="validationErrors.email"
        />

        <!-- BOTÃO DOURADO -->
        <v-btn
          type="submit"
          block
          size="large"
          class="text-white"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          style="
            font-weight: 600;
            background-color: #b99a52;
          "
          @mouseover="hover=true"
          @mouseleave="hover=false"
          :style="hover ? 'background-color: #a18446;' : ''"
        >
          Enviar Código
        </v-btn>
      </v-form>

      <!-- LINK VOLTAR AO LOGIN -->
      <div class="d-flex justify-center mt-4">
        <a
          @click.prevent="goToLogin"
          href="#"
          class="text-body-2 text-decoration-none"
          style="color: #b99a52; font-weight: 600;"
        >
          Lembrou da senha? Voltar ao Login
        </a>
      </div>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import api from "@/services/api";
import { useToastStore } from "@/store/toast";

const email = ref("");
const isSubmitting = ref(false);
const validationErrors = ref({});
const hover = ref(false);

const router = useRouter();
const toastStore = useToastStore();

function validateForm() {
  const errors = {};
  if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
    errors.email = "E-mail inválido ou obrigatório.";
  }
  validationErrors.value = errors;
  return Object.keys(errors).length === 0;
}

async function handleForgotPassword() {
  if (!validateForm()) {
    toastStore.showToast({
      message: "Por favor, informe um e-mail válido.",
      color: "warning",
    });
    return;
  }

  isSubmitting.value = true;

  try {
    const response = await api.post("/forgot-password-request", {
      email: email.value,
    });

    toastStore.showToast({
      message: response.message || "Código de verificação enviado para o seu e-mail!",
      color: "success",
    });

    router.push({ name: "otp-validation", query: { email: email.value } });
  } catch (error) {
    toastStore.showToast({
      message: error?.response?.data?.error || "Erro ao processar a solicitação.",
      color: "error",
    });
  } finally {
    isSubmitting.value = false;
  }
}

const goToLogin = () => router.push({ name: "login" });
</script>

<style scoped>
</style>
